import { useController, useGame } from "../context";
import { FallingIcons, Typewriter } from "../components/effects";

export function StartScreen() {
  const controller = useController();
  const busy = useGame((s) => s.busy);
  return (
    <section className="screen screen--centered">
      <FallingIcons />
      <span className="title-main">Есть контакт</span>
      <div className="start-buttons">
        <button
          type="button"
          className="btn btn--big"
          disabled={busy}
          onClick={() => void controller.createFilterRoom()}
        >
          Выбрать фильм 🎬
        </button>
        <button
          type="button"
          className="btn btn--big"
          onClick={() => void controller.openCollections()}
        >
          Готовые подборки 🎞️
        </button>
        <button type="button" className="btn btn--big" onClick={() => controller.openConnect()}>
          Подключиться 🔗
        </button>
      </div>
      <Typewriter />
    </section>
  );
}
